<template>

    <v-container grid-list-xl>
    <v-divider class="mt-12"></v-divider>
    <h3 class="text-center">Tu pedido nº {{$route.params.id}}</h3>
    <v-divider></v-divider>

                    <v-card
                    class="mx-auto mt-3"
                    color="white"
                >
                <v-list-item three-line>
                <v-list-item-content>
                    <v-list-item-title > 
                       <strong>Dni Cliente:</strong>{{cabecera[$route.params.id-1].cliente}}
                        </v-list-item-title>

                    <v-list-item-subtitle class="black--text">
                       <strong>Total a Cobrar:</strong> S/.{{cabecera[$route.params.id-1].totalacobrar}}
                        </v-list-item-subtitle>
                    <v-list-item-subtitle class="black--text">
                       <strong>Total a Productos:</strong> {{cabecera[$route.params.id-1].totalproductos}}
                        </v-list-item-subtitle>
                      <v-list-item-subtitle class="black--text">
                       <strong>Modo de pago:</strong> {{cabecera[$route.params.id-1].modopago}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="black--text">
                       <strong>Direccion:</strong> {{cabecera[$route.params.id-1].direccion}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="black--text">
                       <strong>Referencia:</strong> {{cabecera[$route.params.id-1].referencia}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="black--text">
                       <strong>Fecha:</strong> {{convertirfecha(cabecera[$route.params.id-1].fechapedido)}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>

                </v-card>
 

        <v-layout row wrap pa-2>
        <v-flex md6
        v-for="carrito in detallepedidos[$route.params.id-1]" :key="carrito"
        >

                <v-card
                    class="mx-auto mt-3"
                    color="white"
                >
                <v-list-item three-line>
                <v-list-item-content>
                    <v-list-item-title class="red--text mt-2"> <strong>{{carrito.categoria}} {{carrito.nombre}} </strong></v-list-item-title>
                   
                    <v-list-item-subtitle class="black--text  mt-1">
                      Precio : <strong>S/.{{carrito.precio}}</strong> </v-list-item-subtitle>

                    <v-list-item-subtitle class=" black--text mt-2">
                      <strong> TALLA  /  COLOR:</strong> </v-list-item-subtitle>

                      <v-list-item-subtitle >
                      <v-avatar class="mr-4 mt-2"
                      size="40">
                       <v-btn fab color="black">
                      <span class="white--text subtitle-1">{{carrito.talla}}</span>
                      </v-btn>
                    </v-avatar>

                      <v-avatar  class="mr-4 mt-2"
                      size="40">
                      <v-btn fab :color="carrito.color">
                      <span class="white--text subtitle-1"></span>
                      </v-btn>
                    </v-avatar>
                      </v-list-item-subtitle>

                    </v-list-item-content>

                <v-list-item-avatar
                    size="100"
                >
                <v-img :src="carrito.color"></v-img>
                
                </v-list-item-avatar>
                </v-list-item>
            </v-card>

        </v-flex>
    </v-layout>
 



  </v-container>
</template>

<script>
import { db } from '../db'
import store from '@/store/index'

  export default {
    name: 'detallepedido',
      components: {

  },
      firebase: {
        cabecera: db.database().ref("cabecera"),
        detallepedidos: db.database().ref("detallepedidos"),
      },

    data() {
        return {
            cabecera:[],
            detallepedidos:[]
        }
      },
    methods:{
              round(num, decimales = 2) {
              var signo = (num >= 0 ? 1 : -1);
              num = num * signo;
              if (decimales === 0) //con 0 decimales
                  return signo * Math.round(num);
              // round(x * 10 ^ decimales)
              num = num.toString().split('e');
              num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
              // x * 10 ^ (-decimales)
              num = num.toString().split('e');
              return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
          },
          convertirfecha(date){
              var objFecha = new Date(date);
             var a = objFecha.toLocaleDateString() + " " +  objFecha.getHours()+ ":" + objFecha.getMinutes() + ":" + objFecha.getSeconds() 
             return a
          }
    }

  }
</script>
